var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-dialog',_vm._b({attrs:{"append-to-body":"","visible":_vm.modelValue,"before-close":_vm.handleClose},on:{"update:visible":function($event){_vm.modelValue=$event}}},'el-dialog',_vm.dialogConfig,false),[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }